<template>
  <header class="guest-header">
    <div class="guest-header__inner">
      <router-link class="brand" to="/">
        <div class="brand-title" aria-label="STREAMMEDIA">
          <span class="brand-word brand-stream">STREAM</span>
          <span class="brand-word brand-media">MEDIA</span>
        </div>
      </router-link>

      <nav class="guest-nav">
        <router-link to="/" class="guest-nav__link" :class="{ active: $route.path === '/' }">Главная</router-link>
        <a href="#" class="guest-nav__link guest-nav__link--placeholder" @click.prevent>Тарифы</a>
        <a href="#" class="guest-nav__link guest-nav__link--placeholder" @click.prevent>FAQ</a>
        <a href="#" class="guest-nav__link guest-nav__link--placeholder" @click.prevent>О нас</a>
      </nav>

      <div class="guest-actions" v-if="!loading">
        <button type="button" class="btn btn-outline-primary btn-sm px-3" @click="goToLogin">Войти</button>
        <button type="button" class="btn btn-primary btn-sm px-3" @click="goToRegister">Регистрация</button>
      </div>
    </div>
  </header>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'HeaderComponent',
  setup() {
    const store = useStore()
    const router = useRouter()

    const loading = computed(() => store.getters.loading)

    const goToLogin = () => {
      router.push('/login')
    }

    const goToRegister = () => {
      router.push('/register')
    }

    return { loading, goToLogin, goToRegister }
  },
}
</script>

<style scoped>
.guest-header {
  position: sticky;
  top: 0;
  z-index: 40;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #e6ebf5;
}

.guest-header__inner {
  height: 66px;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 16px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
}

.brand {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.brand-title {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  letter-spacing: 0.04em;
  user-select: none;
  line-height: 1;
}

.brand-word {
  font-size: 17px;
}

.brand-stream {
  font-weight: 800;
  color: #1f2937;
}

.brand-media {
  font-weight: 700;
  background: linear-gradient(90deg, #8ab4ff, #315ee3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: 0.08em;
}

.guest-nav {
  justify-self: center;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.guest-nav__link {
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: #4b5a78;
  padding: 7px 10px;
  border-radius: 8px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.guest-nav__link:hover {
  background: #f1f5ff;
  color: #234fc2;
}

.guest-nav__link.active {
  background: #eaf1ff;
  color: #234fc2;
}

.guest-nav__link--placeholder {
  color: #7e8aaa;
}

.guest-nav__link--placeholder:hover {
  background: #f5f7fc;
  color: #64749a;
}

.guest-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 768px) {
  .guest-header__inner {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    grid-template-columns: 1fr;
    justify-items: stretch;
    gap: 10px;
  }

  .brand {
    justify-content: center;
  }

  .guest-nav {
    justify-content: center;
  }

  .guest-actions {
    justify-content: center;
  }
}
</style>
